import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  allowedRoles?: Array<'admin' | 'reception' | 'atelier' | 'mecanicien'>;
};

export default function ProtectedRoute({ children, allowedRoles }: Props) {
  const user = useAuthStore((s) => s.user);
  const isHydrating = useAuthStore((s) => s.isHydrating);

  if (isHydrating) {
    return (
      <div className="flex h-screen items-center justify-center text-text-muted text-sm">
        Chargement…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return (
      <div className="flex h-screen items-center justify-center text-text-muted text-sm">
        Accès refusé — permissions insuffisantes.
      </div>
    );
  }

  return <>{children}</>;
}
